import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment";
import _ from "lodash";
import ListFollowUps from "../../../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../../../components/_utils/utils";
import Each from "async/each";
import {
  Row,
  Avatar,
  Button,
  Card,
  Col,
  Checkbox,
  notification,
  Popconfirm,
  Drawer,
  Table,
  Tooltip,
  Select,
  Input,
  DatePicker,
  Form,
  Icon
} from "antd";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import LatestFollowUp from "../../../../components/_utils/latestFollowup";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import Settings from "../../../../components/_utils/settings";
import rightAuth from "../../../../components/_utils/userRights";
import lodash from 'lodash'
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import { hideLoader, showLoader } from '../../../../modules/actions';

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
import ClickToCallDrawer from "../../../Student/inquiry/all/clickToCall";
import ChangeLeadStatusDrawer from "../../../../components/drawers/changeLeadStatusDrawer";

const showDroppedLeads = rightAuth.checkUserRights('showDropLead');

const showDropLead = rightAuth.checkUserRights('dropLead')
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}
const { Search } = Input
const { Option } = Select
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const { RangePicker } = DatePicker

const qualityLevels = ["Qualified", "Potential", "Unqualified"];


class CountryPreference extends React.Component {
  state = {
    visible: true,
    country: null,
    city: null,
    countryArr: [],
    totalPreference: [],

  }

  componentDidMount() {
    this.loadCountries()
    this.loadData()
  }



  loadData = async () => {
    let { inquiryId } = this.props
    let response = await Request.getInquiry(inquiryId)
    if (response && response.doc && response.doc.totalPreference) {
      let x = [];
      Each(
        response.doc.totalPreference,
        async (item, done) => {
          let country = await Request.getCountry(item.countryId);
          let city = "";
          if (item.cityId !== "") {
            city = await Request.getCity(item.cityId);
          }

          let a = {};
          a.country = country.doc;
          a.city = city.doc;
          x.push(a);
          done()
        }, () => {
          this.setState({ totalPreference: x, responseData: response.doc });
        }
      );
      // this.setState({totalPreference: x})
    }
    // this.setState({totalPreference:response.doc.totalPreference})
  }

  loadCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
      businessId: activeUser && activeUser.businessId,
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryFieldArr = [];
        let phoneCodes = [];
        let countryPhoneCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          countryFieldArr.push({ _id: vv._id, display: vv.countryName });
          if (vv.countryPhoneCode) {
            countryPhoneCodes[vv._id] = vv.countryPhoneCode;
            phoneCodes.push(vv.countryPhoneCode);
          }
          temp.push({ ...vv });
          return temp;
        }, []);
        this.setState({ countryArr: resp.data, countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onClose = () => {
    this.setState({
      visible: false
    })

    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  handleSubmit = async () => {
    let totalPreference
    let data = []
    _.each(this.state.totalPreference, (item) => {
      let abc = {};
      abc.country = item.country.countryName;
      abc.city =
        item.city && item.city.cityName != null ? item.city.cityName : "";
      abc.countryId = item.country._id;
      abc.cityId =
        item.city && item.city._id != null ? item.city._id : "";
      data.push(abc);
    });
    totalPreference = data;
    let dataToUpdate = {
      _id: this.props.inquiryId,
      valData: { totalPreference: totalPreference }
    }
    // let data = {
    //     _id:this.props.inquiryId,
    //     valData:{totalPreference:this.state.totalPreference}
    // }
    let response = await Request.updateInquiry(dataToUpdate)
    if (response.success) {
      notification.success({
        message: response.msg
      })
    } else {
      notification.error({
        message: response.msg
      })
    }
    this.setState({
      totalPreference: [],
      country: null,
      city: null
    })
    this.onClose()
  }


  loadCities = (countryId) => {
    return new Promise(async (resolve) => {
      let data = await Request.loadCitiesByCountry(countryId);
      this.setState({ cityArr: data.result });
    });
  };

  render() {
    let { visible } = this.state

    const colum = [
      {
        title: "Country",
        key: "country",
        dataIndex: "country",
        render: (item) => {
          return item.countryName;
        },
      },
      {
        title: "City",
        key: "city",
        dataIndex: "city",
        render: (item) => {
          return item && item.cityName != null ? item.cityName : "";
        },
      },
      {
        title: "Action",
        key: "operation",

        render: (val, record) => (
          <a
            onClick={() => {
              let tt = this.state.totalPreference;
              tt = _.reject(tt, val);
              this.setState({ totalPreference: tt });
            }}
          >
            Remove
          </a>
        ),
      },
    ];
    return (
      <Drawer title={
        <div>
          <React.Fragment>
            Country Preference
          </React.Fragment>
        </div>
      }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={1100}
        visible={visible}>
        <Card>
          <Row gutter={16}>
            <div>
              <div className={"referenceItem"}>
                <div>
                  <h4>Select Countries</h4>
                  <Select
                    placeholder="Select Country"
                    showSearch={true}
                    style={{ width: 200 }}
                    optionFilterProp="children"
                    value={
                      this.state.country
                        ? this.state.country._id
                        : undefined
                    }
                    onChange={(ei) => {
                      let singleCountry = _.find(
                        this.state.countryArr,
                        (item) => {
                          return item._id == ei;
                        }
                      );

                      if (singleCountry) {
                        this.loadCities(singleCountry._id);
                      }
                      this.setState({ country: singleCountry, city: null });
                    }}
                  >
                    {this.state.countryArr.map((val, index) => {
                      return (
                        <Option key={index} value={val._id}>
                          {val.countryName}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                <div>
                  <h4>Select Cities</h4>

                  <Select
                    placeholder="Select City"
                    showSearch={true}
                    optionFilterProp="children"
                    style={{ width: 200 }}
                    value={
                      this.state.city ? this.state.city._id : undefined
                    }
                    onChange={(ei) => {
                      let singleCity = _.find(
                        this.state.cityArr,
                        (item) => {
                          return item._id == ei;
                        }
                      );
                      if (singleCity) {
                        this.loadCities(singleCity._id);
                      }
                      this.setState({ city: singleCity });
                    }}
                  >
                    {this.state.cityArr &&
                      this.state.cityArr.map((val, index) => {
                        return (
                          <Option key={index} value={val._id}>
                            {val.cityName}
                          </Option>
                        );
                      })}
                  </Select>
                </div>

                <div>
                  <Button
                    style={{
                      marginTop: 25,
                      marginBottom: 23,
                    }}
                    size={"small"}
                    onClick={() => {
                      if (!this.state.country) {
                        return notification.error({
                          message: "Choose Country",
                        });
                      }

                      if (this.state.country) {
                        let tt = this.state.totalPreference;
                        tt.push({
                          country: this.state.country,
                          city: this.state.city,
                        });
                        this.setState(
                          {
                            totalPreference: tt,
                            city: null,
                            country: null,
                          },
                          () => { }
                        );
                      }
                    }}
                  >
                    ADD TO PREFERENCES
                  </Button>
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                size={"small"}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: false,
                  showQuickJumper: false,
                }}
                bordered={true}
                columns={colum}
                dataSource={this.state.totalPreference}
              />
            </Col>
          </Row>
          <Button onClick={() => {
            this.handleSubmit()
          }}>SAVE</Button>
        </Card>
      </Drawer>
    )
  }
}

class CollapseViewBox extends Component {
  state = {
    cp: false,
  };

  render() {
    const { cp } = this.state;
    const clondData = this.props.children;
    return (
      <React.Fragment>
        <div>
          <div
            className={
              cp ? styles.questioncollapse : styles.questioncollapsenot
            }
          >
            {clondData && clondData.course &&
              clondData.course
                .slice(0, cp ? clondData.course.length : 1)
                .map((item) => {
                  return (
                    <ul className={styles.ul}>
                      <li>
                        <b>{item.courseName}{item.campusName && `(${item.campusName})`}</b>
                      </li>
                      <li>{item.universityInstitutionName}</li>
                      <li>
                        <small>
                          {" "}
                          {item.univData &&
                            item.univData.universityCityId &&
                            `${item.univData.universityCityId.cityName} ,`}
                          {item.univData &&
                            item.univData.universityStateId &&
                            `${item.univData.universityStateId.stateName} ,`}
                          {item.univData &&
                            item.univData.universityCountryId &&
                            `${item.univData.universityCountryId.countryName}`}
                        </small>
                      </li>
                    </ul>
                  );
                })}
          </div>
          {clondData && clondData.course && clondData.course.length > 1 ? (
            <button
              style={{ color: "red" }}
              onClick={() => {
                this.setState({
                  cp: !cp,
                });
              }}
            >
              {cp ? <p>View Less - </p> : <p>View More + </p>}
            </button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}


@Form.create()
class ChangeCounsellors extends Component {
  state = {
    visible: true,
    loading: false
  }

  componentDidMount() {
  }

  handleSubmit = (e) => {
    let { form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      values.studentIds = counsellingData.usersData;
      this.setState({ loading: true });
      let response = await Request.changeMultipleCounsellors(values);
      this.setState({ loading: false });
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose();
    })
  }


  onClose = () => {
    this.setState({ visible: false });
    setTimeout(() => {
      this.props.onClose()
    }, 50)
  }


  render() {
    let { visible, loading } = this.state;
    let { form: { getFieldDecorator, setFieldsValue }, counsellors } = this.props;
    counsellors = counsellors.slice(1);
    const inputTypes = {
      fields: [
        {
          label: 'Choose Counsellor',
          key: 'counsellorId',
          required: true,
          type: 'select',
          showSearch: true,
          options: counsellors,
          onChange: v => {
            setFieldsValue({ counsellorId: v })
          }
        }
      ]
    }
    return (
      <Drawer title={
        <div>
          <React.Fragment>
            Change Counsellor
          </React.Fragment>
        </div>
      }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields apiurl={LAPI_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

class CounsellingDesk extends Component {
  state = {
    search_keyword: '',
    count: 0,
    followDuesCount: 0,
    showFollowUp: false,
    studentId: null,
    studentSearchId: '',
    branchId: "",
    counsellorId: "",
    exdCounsellorId: [],
    allBranches: [],
    allCounsellor: [],
    counsellors: [],
    ratingArr: [],
    subRatingArr: [],
    leadStatusArr: [],
    leadStatusesObject: {},
    modeArr: [],
    deskColor: null,
    showCallDrawer: false,
    recordForCall: {},
    prferenceDrawer: false,
    inquiryId: null,
    time: {
      key: "createdByUser.time",
      from: null,
      to: null,
    },
    courseList: [],
    selectStudentId: "",
    ratingId: "",
    subRatingId: "",
    courseDrawer: false,
    isFollowUpOverdue: false,
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    userCheckBox: {},
    exportParams: {},
    showDropped: false,
    showChangeCounsellorDrawer: false,
    showUpdateLeadStatus: false,
    leadStatus: null,
    counsellingDeskRights: {}
  };
  reload = () => {
    this.table.current.reload();
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showSMS: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeSMS = () => {
    this.setState({ showSMS: false })
  }
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return (item.isChecked === true ? item : false);
    })

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showWhatsAppSms: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false })
  }
  closeEmail = () => {
    this.setState({ showEmail: false })
  }
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showEmail: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }


  changeCounsellorInBulk = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showChangeCounsellorDrawer: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }


  }


  dropLeads = async () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      let response = await Request.dropInquiry(counsellingData)
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: 'Something Went Wrong'
        })
      }
      this.reload()
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }

  toggleDroppedLeads = () => {
    let showDropped = this.state.showDropped;
    showDropped = !showDropped
    this.setState({ showDropped }, () => {
      this.reload()
    })
  }
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    if (cloneUserCheckBox[studentId] === undefined) {
      cloneUserCheckBox[studentId] = [];
    }
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
    this.setState({ userCheckBox: cloneUserCheckBox })
  }
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true
    })
    this.setState({ userCheckBox: cloneUserCheckBox })
  }
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false
    })
    this.setState({ userCheckBox: cloneUserCheckBox })
  }

  exportExcel = async () => {
    const { exportParams, count } = this.state
    exportParams.results = count
    exportParams.count = count
    let x = await Request.exportCounsellingDeskToExcel({ ...exportParams })
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url)
    }
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      params.dropped = this.state.showDropped
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
      }
      if (this.state.search_keyword && this.state.search_keyword !== "") {
        params.keyword = this.state.search_keyword
      }
      if (this.state.exdCounsellorId) {
        params.exdCounsellorId = this.state.exdCounsellorId;
      }
      if (this.state.ratingId) {
        params["counsellingDesk.rating"] = this.state.ratingId;
      }
      if (this.state.subRatingId) {
        params["counsellingDesk.subRating"] = this.state.subRatingId;
      }
      if (this.state.studentSearchId) {
        params.studentSearchId = this.state.studentSearchId
      } else {
        params.studentSearchId = '';
      }

      if (this.state.leadStatus) {
        params.leadStatus = this.state.leadStatus;
      }


      let searchParams = new URLSearchParams(this.props.search);
      let ratingId = searchParams.get("ratingId");
      let subRatingId = searchParams.get("subRatingId");
      if (ratingId) {
        params["counsellingDesk.rating"] = ratingId;
      }
      if (subRatingId) {
        params["counsellingDesk.subRating"] = subRatingId;
      }

      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
      }
      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: moment(params.dateOfBirth, dateFormat).startOf('day'),
          $lt: moment(params.dateOfBirth, dateFormat).endOf('day'),
        };
      } else {
        delete params.dateOfBirth;
      }

      params.atLevel = ["Counselling Desk"];

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }
      let data = await Request.loadCounselling({
        ...params,
        regExFilters: [
          "studentName",
          "location",
          "email",
          "mobile",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false
          }
        }
      })

      this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox, exportParams: params, leadStatusSummary: data.leadStatusSummary || {} });
      resolve(data);
    });
  };

  closeFollowUp = () => {
    this.setState({
      showFollowUp: false,
    }, () => {
      this.table.current.reload()
    });
  };

  openFollowUps = (record) => {
    let leadStatus = record && record.leadStatus;
    if (!leadStatus) {
      notification.error({
        message: "Lead Status Required",
        description: "Please assign a lead status before adding notes."
      });
      return;
    }
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
    }
  }

  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000
    })
    let sourceObject = [];
    response.data && response.data.map((source) => {
      sourceObject.push(source.sourceName)
    })
    this.setState({ modeArr: sourceObject })
  }

  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };
  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "createdByUser.time",
          from: moment(date[0]).startOf('day'),
          to: moment(date[1]).endOf('day'),
        },
      },
      () => {
        this.reload();
      }
    );
    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };

  onOk = value => {
    this.reload()
  }

  async componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);
    let createdByUserDate = searchParams.get("dateFilter");
    if (createdByUserDate) {
      this.setState(
        {
          time: {
            key: "createdByUser.time",
            from: moment(createdByUserDate, "DD-MM-YYYY")
              .startOf("day")
              .toDate(),
            to: moment(createdByUserDate, "DD-MM-YYYY")
              .endOf("day")
              .toDate(),
          },
        },
        () => {
          console.log("adsffs", this.state.time);
        }
      );
    }
    this.setState({ deskColor: Settings.deskColor("Front Desk") });


    let ratingId = searchParams.get("ratingId");
    let subRatingId = searchParams.get("subRatingId");
    if (ratingId || subRatingId) {
      setTimeout(() => {
        this.table.current.reload()
      }, 1000);
    }
  }

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000
    })
    this.setState({ ratingArr: response.data })
  }

  getAllSubRatings = async (parentRatingId) => {
    let response = await Request.getSubRatingsDetails({
      results: 1000,
      count: 1000,
      parentRatingId: parentRatingId
    })
    this.setState({ subRatingArr: response.data })
  }

  getAllLeadStatuses = async () => {
    let response = await Request.getLeadStatusDetails({
      results: 1000,
      count: 1000,
      desk: 'Front Desk'
    });
    let leadStatusesObject = {};
    if (response && response.data) {
      response.data.forEach(item => {
        leadStatusesObject[item._id] = item;
      });
      this.setState({ leadStatusArr: response.data, leadStatusesObject })
    }
  }

  constructor(props) {
    super(props);
    this.loadCountries();
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then(resp => {
        if (resp) {
          let temp = [{ display: '---Show All---', id: '' }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name
            vv.id = vv._id
            temp.push(vv)
            return temp
          }, []);
          this.setState({ counsellors: resp.data })
        }
      })
      .catch(err => {
      })
  }

  async loadCountries() {
    let { data: countriesList } = await Request.getCountriesWithoutAuth({
      results: 10000,
      businessId: activeUser && activeUser.businessId
    })
    let countryList = []
    _.each(countriesList, (item) => {
      countryList.push({ value: item.countryName, text: item.countryName })
    })
    this.setState({ allcountries: countryList })
  }

  loadUserRights = async () => {
    let { userRights } = await Request.loadUserRights()
    let counsellingDeskRights = userRights.CounsellingDesk;
    this.setState({ counsellingDeskRights })
  }


  async loadData() {
    await this.getAllRatings();
    await this.getAllLeadStatuses();
    await this.getAllSource();
    let { data } = await Request.loadDeskUser({
      results: 10000,
      isCounsellor: true,
      active: true
    });
    this.setState({
      allCounsellor: data,
      loading: false,
    });
  }

  async componentDidMount() {
    this.loadUserRights();
    this.loadData();

    window.onkeydown = function (e) {
      var ck = e.keyCode ? e.keyCode : e.which;
      if (e.ctrlKey && ck == 70) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      } else if (ck == 27) {
        if (document.querySelector('#search-student-input')) {
          document.querySelector('#search-student-input').focus();
        }
        return false;
      }
    }

  }

  closeCallDrawer = () => {
    this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
      this.reload()
    })
  }

  changeSearchValue = (value) => {
    this.setState({ search_keyword: value }, () => {
      this.table.current.reload()
    })
  }


  closePreferenceDrawer = () => {
    this.setState({
      prferenceDrawer: false,
      inquiryId: null
    }, () => {
      this.table.current.reload();
    })
  }


  closeChangeCounsellorDrawer = () => {
    this.setState({
      showChangeCounsellorDrawer: false
    }, () => {
      this.table.current.reload();
    })
  }

  async getStudentCourse(inquiryId) {
    this.setState({ loading: true });
    let { doc } = await Request.getInquiry(inquiryId);
    this.setState({ loading: false });
    if (doc) {
      let counsellingDesk = doc.counsellingDesk;
      this.setState({
        courseList: counsellingDesk.course,
        courseDrawer: true,
      });
    }
  }
  showChangeLeadStatus = async (inquiryId) => {
    this.setState({ showUpdateLeadStatus: true, inquiryId });
  }

  closeChangeLeadStatus = () => {
    this.setState({ showUpdateLeadStatus: false, inquiryId: null }, () => {
      this.table.current.reload();
    })
  }

  followUpsCallback() {
    let { isFollowUpOverdue } = this.state;
    this.setState({
      isFollowUpOverdue: !isFollowUpOverdue,
    }, () => {
      this.table.current.reload()
    });
  }

  handleStudentMoveStudy = async (data) => {
    let response = await Request.moveStudentToStudy(data);
    if (!response.error) {
      this.table.current.reload()
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
  }


  render() {
    const { dispatch } = this.props;
    const {
      allBranches = [],
      allCounsellor = [],
      deskColor,
      ratingArr,
      leadStatusArr,
      leadStatusesObject,
      modeArr,
      allcountries = [],
      counsellors,
      subRatingArr,
      showCallDrawer,
      recordForCall,
      showUpdateLeadStatus,
      inquiryId,
      leadStatusSummary = {},
      counsellingDeskRights = {},
    } = this.state;

    const COLORS = ["#16a34a", "#ea580c", "#2563eb", "#7c3aed", "#d97706", "#059669", "#2563eb", "#4f46e5", "#c026d3", "#e11d48"];

    // const statCards = (leadStatusArr || [])
    //   .filter((s) => s && s.statusName)
    //   .map((status, index) => {
    //     const statusId = status._id;
    //     const statusName = status.statusName;
    //     const count = leadStatusSummary[statusId] || 0;
    //     const color = COLORS[index % COLORS.length];

    //     return (
    //       <Col
    //         key={statusId}
    //         span={4}
    //         style={{ marginBottom: "1rem" }}
    //         onClick={() => {
    //           this.setState(
    //             { leadStatus: statusId },
    //             () => {
    //               setTimeout(() => {
    //                 if (this.table && this.table.current) this.table.current.reload();
    //               }, 500);
    //             }
    //           );
    //         }}
    //       >
    //         <div className={styles.statCard} style={{ padding: '15px 20px', background: '#fff', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', display: 'flex', flexDirection: 'column' }}>
    //           <div className={styles.mutedText} style={{ marginBottom: 8, fontSize: '14px', color: '#8c8c8c' }}>{statusName}</div>
    //           <div className={styles.statValue} style={{ fontSize: '28px', fontWeight: 'bold', color: color, lineHeight: 1 }}>
    //             {count}
    //           </div>
    //         </div>
    //       </Col>
    //     );
    //   });

    const statCards = [
      ...(leadStatusArr || [])
        .filter((s) => s && s.statusName)
        .map((status, index) => {
          const statusId = status._id;
          const statusName = status.statusName;
          const count = leadStatusSummary[statusId] || 0;
          const color = COLORS[index % COLORS.length];

          return (
            <Col
              key={statusId}
              span={4}
              style={{ marginBottom: "1rem" }}
              onClick={() => {
                this.setState(
                  { leadStatus: statusId },
                  () => {
                    setTimeout(() => {
                      if (this.table && this.table.current) {
                        this.table.current.reload();
                      }
                    }, 500);
                  }
                );
              }}
            >
              <div
                className={styles.statCard}
                style={{
                  padding: "15px 20px",
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <div
                  className={styles.mutedText}
                  style={{
                    marginBottom: 8,
                    fontSize: "14px",
                    color: "#8c8c8c"
                  }}
                >
                  {statusName}
                </div>

                <div
                  className={styles.statValue}
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    color: color,
                    lineHeight: 1
                  }}
                >
                  {count}
                </div>
              </div>
            </Col>
          );
        }),

      // Last card
      <Col
        key="followups"
        span={4}
        style={{ marginBottom: "1rem" }}
        onClick={this.followUpsCallback}
      >
        <div
          className={styles.statCard}
          style={{
            padding: "15px 20px",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            className={styles.mutedText}
            style={{
              marginBottom: 8,
              fontSize: "14px",
              color: "#8c8c8c"
            }}
          >
            Follow-Ups
          </div>

          <div
            className={styles.statValue}
            style={{
              fontSize: "28px",
              fontWeight: "bold",
              color: "#1890ff",
              lineHeight: 1
            }}
          >
            {this.state.followDuesCount}
            {/* {Object.values(leadStatusSummary || {}).reduce(
              (total, count) => total + count,
              0
            )} */}
          </div>
        </div>
      </Col>
    ];

    const columns = [
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        // fixed: true,
        width: 190,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Select">
              <span className={styles.userSelectCheckbox}>
                <Checkbox
                  checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                  onChange={y => {
                    this.selectUser(y, record._id)
                  }}>
                </Checkbox>
              </span>
            </Tooltip>&nbsp;
            <Tooltip title="Notes">
              <Button
                className={styles.btn}
                size={"small"}
                shape="circle"
                onClick={() => this.openFollowUps(record)}
                icon="calendar"
              />
            </Tooltip>&nbsp;
            <Tooltip title="Click To Edit Details">
              <Button
                className={styles.btn}
                shape="circle"
                size={"small"}
                href={`/desk/update-counselling?id=${record._id}`}
                icon="edit"
              />
            </Tooltip>&nbsp;
            <Tooltip title="Click To View Courses">
              <Button
                className={styles.btn}
                shape="circle"
                size={"small"}
                onClick={() => {
                  this.getStudentCourse(record._id);
                }}
                icon="eye"
              />
            </Tooltip>
            <Tooltip title="Update Lead Status">
              <Button className={styles.btn}
                shape="circle"
                size={"small"}
                style={{ marginLeft: 2 }}
                onClick={() => {
                  this.showChangeLeadStatus(record._id);
                }}
                icon="sync">

              </Button>
            </Tooltip>
            {!record.movedForStudy ? (
              <RightsWrapper myRight={'moveStudentToTMaster.view'}>
                <span>
                  <Tooltip title="Move Student to T-Master ">
                    <Popconfirm
                      title="Are you sure to move student"
                      onConfirm={() => this.handleStudentMoveStudy(record)}
                    >
                      <Button
                        className={styles.btn}
                        size={"small"}
                        style={{ marginLeft: 2 }}
                        shape="circle"
                        icon="forward"
                      />
                    </Popconfirm>
                  </Tooltip>
                </span>
              </RightsWrapper>
            ) : null}
            <RightsWrapper myRight={'changeCountryPreference.view'}>
              <Tooltip title="Click To Change Country Preference">
                <Button
                  className={styles.btn}
                  shape="circle"
                  size={"small"}
                  style={{ marginLeft: 2 }}
                  onClick={() => {
                    this.setState({ prferenceDrawer: true, inquiryId: record._id })
                  }}
                  icon="global"
                />
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        ),
      },
      {
        title: "VID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        width: 80,
        // fixed: true,
        searchTextName: "id",
        filterRegex: true,
      },
      // {
      //   title: "Student Name",
      //   key: "studentName",
      //   dataIndex: "studentName",
      //   sorter: true,
      //   fixed: true,
      //   searchTextName: "studentName",
      //   filterRegex: true,
      //   render: (text, record) => (
      //     <React.Fragment>
      //       <div
      //         className={
      //           this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
      //         }
      //       >
      //         <Tooltip title="Click To View Student Details">
      //           <a
      //             className={styles.btn}
      //             target={"_blank"}
      //             href={`/inquiry/studentProfileDetails?id=${record._id}`}
      //           >
      //             {text}
      //           </a>
      //         </Tooltip>
      //       </div>

      //     </React.Fragment>
      //   ),
      // },
      {
        title: `Student Name / DOB / Email`,
        key: 'studentBasicDetail',
        dataIndex: 'studentName',
        width: 190,
        searchTextName: `Student Name / DOB / Email`,
        filterRegex: true,
        render: (text, record) => {
          var dob = record && record.dateOfBirth
            ? moment(record.dateOfBirth).format(dateFormat)
            : '';

          var email = record && record.emailId
            ? record.emailId
            : (record && record.email ? record.email : (record && record.profile ? record.profile.emailId : ''));

          return (
            <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
              {/* 1. Primary Student Name Link */}
              <div style={{ marginBottom: '4px' }}>
                <Tooltip title="View Profile">
                  <a
                    style={{
                      color: '#1890ff',
                      fontWeight: 700,
                      fontSize: '13px',
                      letterSpacing: '0.2px',
                      textDecoration: 'none'
                    }}
                    target={'_blank'}
                    rel="noopener noreferrer"
                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                  >
                    {text}
                  </a>
                </Tooltip>
              </div>

              {/* 2. Date of Birth */}
              {dob && (
                <div style={{ fontSize: '11px', color: '#595959', marginBottom: '2px', display: 'flex', alignItems: 'center' }}>
                  <Icon type="calendar" style={{ marginRight: '4px', color: '#bfbfbf' }} />
                  <span>{dob}</span>
                </div>
              )}

              {/* 3. Student Email ID */}
              {email && (
                <div style={{ fontSize: '11px', color: '#8c8c8c', wordBreak: 'break-all', display: 'flex', alignItems: 'center' }}>
                  <Icon type="mail" style={{ marginRight: '4px', color: '#bfbfbf' }} />
                  <span>{email}</span>
                </div>
              )}
            </div>
          );
        }
      },
      // {
      //   title: "Date of Birth ",
      //   width: 100,
      //   key: "dateOfBirth",
      //   dataIndex: "dateOfBirth",
      //   searchTextName: `${dateFormat}`,
      //   render: (val, record) => {
      //     return (
      //       <div>
      //         {record.dateOfBirth
      //           ? moment(record.dateOfBirth).format(dateFormat)
      //           : ""}
      //       </div>
      //     );
      //   },
      // },
      // {
      //   title: 'Passport No',
      //   key: 'passportNo',
      //   searchTextName: 'passportNo',
      //   filterRegex: true,
      //   width: 150,
      //   dataIndex: 'visaDesk.passportNo'
      // },
      ...(counsellingDeskRights && !counsellingDeskRights.viewById ? [{
        title: "Mode",
        key: "mode",
        width: 100,
        dataIndex: "mode",
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x }))
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        width: 120,
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      }
      ] : []),
      {
        title: 'Quality Rating',
        width: 120,
        key: 'qualityRating',
        dataIndex: "counsellingDesk.qualityRating",
        filters: qualityLevels.map((x) => ({ value: x, text: x })),
        render: (val, record) => (
          <span>{record && record.counsellingDesk && record.counsellingDesk.qualityRating}</span>
        )
      },
      {
        title: "Conversion Rating",
        width: 120,
        key: "rating",
        dataIndex: "counsellingDesk.rating",
        filters: ratingArr
          ? [...ratingArr, { _id: "No Rating", ratingName: "No Rating" }].map((x) => ({
            value: x._id,
            text: x.ratingName
          }))
          : [],
        render: (val, record) => {

          let ratingObject = record.counsellingDesk && record.counsellingDesk.ratingObject ? record.counsellingDesk.ratingObject : null;
          let subRatingObject = record.counsellingDesk && record.counsellingDesk.subRatingObject ? record.counsellingDesk.subRatingObject : null;
          return (
            <div>
              {
                ratingObject ?
                  <div className="antd-pro-containers-desk-counselling-all-styles-rating" style={{ background: ratingObject.ratingColor, borderColor: ratingObject.ratingColor }}>{ratingObject.ratingName} {subRatingObject && subRatingObject.ratingName ? ('/ ' + subRatingObject.ratingName) : ''}</div>
                  :
                  this.renderStatus(val)
              }
            </div>
          )
        },
      },
      {
        title: "Lead Status",
        width: 120,
        key: "leadStatus",
        filters: leadStatusArr && leadStatusArr.map((x) => ({ value: x._id, text: x.statusName })),
        render: (val, record) => {
          let lsId = record.leadStatus;
          let lsObj = lsId ? leadStatusesObject[lsId] : null;
          return lsObj ? lsObj.statusName : "-";
        }
      },
      {
        title: "Follow-Up Note",
        key: "followUp",
        width: 160,
        searchTextName: "followUp",
        filterRegex: true,
        dataIndex: "followUp",
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      // {
      //   title: 'Last FollowUp By',
      //   key: 'followUp.assignByName',
      //   searchTextName: 'Last FollowUp By',
      //   filterRegex: true,
      //   width: 160,
      // },
      {
        title: "Country Preference",
        key: "preference",
        width: 120,
        filters: allcountries,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val ? val.country : ""}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      // {
      //   title: "Course/University",
      //   key: "counsellingDesk.course",
      //   width: 280,
      //   dataIndex: "course",
      //   render: (text, record) => {
      //     return <CollapseViewBox>{record.counsellingDesk}</CollapseViewBox>;
      //   },
      // },
      // {
      //   title: "Test Score",
      //   key: "ieltsOverallScore",
      //   dataIndex: "ieltsOverallScore",
      //   searchTextName: "ieltsOverallScore",
      //   filterRegex: true,
      //   width: 180,
      //   render: (text, record) => {
      //     return (
      //       <div style={{ fontSize: "12px" }}>
      //         <div style={{ paddingBottom: "4px" }}>
      //           {" "}
      //           {record.testType && text
      //             ? `${record.testType} OverAll : ${text}`
      //             : null}
      //         </div>
      //         <div style={{ paddingBottom: "4px" }}>
      //           {record && record.profile && record.profile.reading
      //             ? `Reading : ${record.profile.reading}`
      //             : null}{" "}
      //           {record && record.profile && record.profile.writing
      //             ? `Writing : ${record.profile.writing}`
      //             : null}{" "}
      //         </div>
      //         <div>
      //           {record && record.profile && record.profile.listening
      //             ? `Listening : ${record.profile.listening}`
      //             : null}{" "}
      //           {record && record.profile && record.profile.speaking
      //             ? `Speaking : ${record.profile.speaking}`
      //             : null}
      //         </div>
      //       </div>
      //     );
      //   },
      // },
      {
        title: "Contact Details",
        key: "mobwap",
        width: 120,
        dataIndex: "mobwap",
        searchTextName: "MOB/WAP/Mail",
        render: (val, record) => {
          return (
            <div>
              <div>
                {" "}
                {record.mobile &&
                  record.mobile.length >= 10 &&
                  rightAuth.checkRights("ShowClickToCall.view") ? (
                  <Tooltip title="Start Call">
                    <Button
                      className="ant-btn ant-btn-primary"
                      onClick={() => {
                        this.setState({ showCallDrawer: true, recordForCall: record })
                      }}
                    // onClick={(e) => {

                    //   dispatch(showLoader());
                    //   Request.callInitiate({
                    //     mobile: record.mobile,
                    //   }).then(({ data, error, message }) => {
                    //     dispatch(hideLoader());
                    //     if (!error) {
                    //       notification.success({
                    //         message: message,
                    //       });
                    //     } else {
                    //       notification.error({
                    //         message: message,
                    //       });
                    //     }
                    //   });
                    // }}
                    >
                      Click To Call
                    </Button>
                  </Tooltip>
                ) : (
                  record.mobile
                )}
              </div>
              {/* <div>
                <span>
                  {record.mobile && record.mobile.length === 10 && rightAuth.checkRights("ShowClickToCall.view") ? (
                    <Tooltip title="Start Call">
                      <Button
                        className='ant-btn ant-btn-primary'
                        onClick={(e) => {
                          dispatch(showLoader())
                          Request.callInitiate({
                            mobile: record.mobile,

                          }).then(({ data, error, message }) => {
                            dispatch(hideLoader())
                            if (!error) {
                              notification.success({
                                message: message
                              })
                            } else {
                              notification.error({
                                message: message
                              })
                            }
                          })
                        }}
                      >
                        Click To Call
                      </Button>
                    </Tooltip>
                  ) : (
                    record.mobile
                  )}
                </span>
              </div> */}
              <div>
                {record.watsupp && record.watsupp.length === 10 ? (
                  <Tooltip title="Share on Whatsapp">
                    <a
                      target={"_blank"}
                      style={{ textDecoration: "underline" }}
                      href={`http://api.whatsapp.com/send?phone=91${record.watsupp
                        }&text=&source=&data=`}
                    >
                      {record.watsupp}
                    </a>
                  </Tooltip>
                ) : (
                  record.watsupp
                )}
              </div>
              {/* <div>
                <span>{record.emailId}</span>
              </div> */}
            </div>
          );
        },
      },
      // {
      //   title: "Source",
      //   key: "location",
      //   dataIndex: "location",
      //   searchTextName: "location",
      //   filterRegex: true,
      // },
      ...(counsellingDeskRights && !counsellingDeskRights.viewById ? [{
        title: "Branch",
        key: "studentBranchId",
        filters: allBranches,
        width: 120,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      }] : []),
      {
        title: "Created / Updated By",
        width: 170,
        key: "userActivity",
        render: (text, record) => {
          var created = record && (record.createdByUser || record.createdBy);
          var updated = record && (record.updatedByUser || record.updatedBy);

          return (
            <div style={{ lineHeight: "1.4", fontSize: "12px" }}>
              {/* Created By Section */}
              {created && (
                <div style={{ marginBottom: updated ? "6px" : "0" }}>
                  <div style={{ color: "#8c8c8c", fontSize: "10px", fontWeight: 600, textTransform: "uppercase" }}>
                    Created By
                  </div>
                  <div className={common.user} style={{ fontWeight: 500, color: "#262626" }}>
                    {created.name || "-"}
                  </div>
                  <small style={{ color: "#8c8c8c", fontSize: "10px" }}>
                    {created.time ? moment(created.time).format("lll") : (record.created_at ? moment(record.created_at).format("lll") : "")}
                  </small>
                </div>
              )}

              {/* Updated By Section */}
              {updated && (
                <div>
                  <div style={{ color: "#8c8c8c", fontSize: "10px", fontWeight: 600, textTransform: "uppercase" }}>
                    Updated By
                  </div>
                  <div className={common.user} style={{ fontWeight: 500, color: "#262626" }}>
                    {updated.name || "-"}
                  </div>
                  <small style={{ color: "#8c8c8c", fontSize: "10px" }}>
                    {updated.time ? moment(updated.time).format("lll") : (record.updated_at ? moment(record.updated_at).format("lll") : "")}
                  </small>
                </div>
              )}

              {!created && !updated && <span style={{ color: "#bfbfbf" }}>-</span>}
            </div>
          );
        },
      }


      // {
      //   title: "Photo",
      //   key: "profilePic",
      //   width: 60,
      //   dataIndex: "profilePic",
      //   render: (val) => {
      //     return <Avatar src={val} />;
      //   },
      // },


    ];

    const courseColumns = [
      {
        title: "Course Name",
        dataIndex: "courseName",
        key: "courseName",
      },
      {
        title: "University",
        dataIndex: "universityInstitutionName",
        key: "universityInstitutionName",
      },
      {
        title: "PathWay",
        dataIndex: "pathwayName",
        key: "pathwayName",
      },
      {
        title: "Fees/Duration",
        width: 150,
        key: "tutionFee",
        dataIndex: "tutionFee",
        render: (val, record) => {
          return (
            <div>
              <span>{record.tutionFee} /</span>
              <span>{record.courseDuration}</span>
            </div>
          );
        },
      },
    ];

    return (
      <PageHeaderWrapper
        deskColor={deskColor}
        title={` COUNSELLING DESK : ${this.state.count} `}
      // subTitle={`Follow Up Overdue : ${this.state.followDuesCount}`}
      // followUpsCallback={this.followUpsCallback}
      >

        {
          showCallDrawer ?
            <ClickToCallDrawer record={recordForCall} type="inquiry" onClose={this.closeCallDrawer} />
            : null
        }
        {
          showUpdateLeadStatus ?
            <ChangeLeadStatusDrawer inquiryId={inquiryId} onClose={this.closeChangeLeadStatus} />
            : null
        }
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}
        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
        ) : null}

        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
        ) : null}

        {this.state.prferenceDrawer ?
          <CountryPreference inquiryId={this.state.inquiryId} onClose={this.closePreferenceDrawer} />
          : null}

        {
          this.state.showChangeCounsellorDrawer ?
            <ChangeCounsellors counsellors={counsellors} onClose={this.closeChangeCounsellorDrawer} />
            : null
        }

        {/* ========== LEAD STATUS SUMMARY CARDS ========== */}
        {statCards.length > 0 && (
          <div className={styles.stickyLeadStats}>
            <Row gutter={16} type="flex" style={{ marginBottom: 0 }}>
              {statCards}
            </Row>
          </div>
        )}
        {/* {statCards.length > 0 && (
          <Row gutter={16} type="flex" style={{ marginBottom: '5px' }}>
            {statCards}
          </Row>
        )} */}

        <Card style={{ marginBottom: 10 }}>
          <div style={{ display: 'flex' }}>
            <Col style={{ marginRight: '1rem' }}>
              <label style={{ display: 'block' }}>Date of Lead Addition </label>


              <RangePicker style={{ width: '90%' }}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
            {
              counsellingDeskRights && !counsellingDeskRights.viewById && (
                <Col span={7}>
                  <label>Exclude Counsellors</label>

                  <Select
                    allowClear
                    style={{
                      width: '90%'

                    }}
                    mode="tags"
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.exdCounsellorId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    filterOption={(input, option) => {
                      return (
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      )
                    }}
                    onChange={exdCounsellorId => {
                      this.setState(
                        {
                          exdCounsellorId: exdCounsellorId
                        },
                        () => {
                          setTimeout(() => {
                            this.table.current.reload()
                          }, 500);
                        }
                      );
                    }}>
                    {
                      allCounsellor.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>
                            {val.name}
                          </Option>
                        )
                      })
                    }
                  </Select>
                </Col>
              )
            }

            {/* <Col span={4}>
              <label>Rating</label>

              <Select
                allowClear
                style={{
                  width: '90%'
                }}
                placeholder="Select Rating"
                onChange={(ratingId) => {
                  this.setState({
                    ratingId,
                    subRatingId: ''
                  }, () => {
                    setTimeout(() => {
                      this.table.current.reload()
                    }, 500);
                  })
                  this.getAllSubRatings(ratingId)
                }}
              >
                {ratingArr.map((val, idn) => (
                  <Option key={idn} value={val._id}>{val.ratingName}</Option>
                ))}
              </Select>
            </Col>
            <Col span={4}>
              <label>Sub-Rating</label>

              <Select
                allowClear
                style={{
                  width: '90%'
                }}
                value={this.state.subRatingId}
                placeholder="Select Sub Rating"
                onChange={(subRatingId) => {
                  this.setState(
                    {
                      subRatingId
                    }, () => {
                      setTimeout(() => {
                        this.table.current.reload()
                      }, 500);
                    }
                  )
                }}
              >
                {subRatingArr.map((val, idn) => (
                  <Option key={idn} value={val._id}>{val.ratingName}</Option>
                ))}
              </Select>
            </Col> */}
            <Col span={4}>
              {
                rightAuth.checkRights("ConsellingDeskExcelExport.view") ?
                  <Button
                    style={{ marginTop: '15px' }}
                    type="primary"
                    onClick={() => this.exportExcel()}>
                    Export Excel
                  </Button>
                  : null
              }

            </Col>
          </div>
        </Card>

        <Card bordered={true} style={{ marginBottom: 10 }}>
          <Row>
            {/* Fixed Buttons */}
            <Col span={12}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => this.showEmail()}>Send E-mail
              </Button>
              <Button style={{ marginLeft: '1rem' }}
                type="primary"
                className={styles.btn}
                onClick={() => this.showSMS()}>Send SMS
              </Button>
              <Button style={{ marginLeft: '1rem' }}
                type="primary"
                className={styles.btn}
                onClick={() => this.showWhatsAppSms()}>Whatsapp
              </Button>
              <Button style={{ marginLeft: '1rem' }}
                className={styles.btn}
                onClick={() => this.selectAllUserFxn()}>Select Visible
              </Button>
              <Button style={{ marginLeft: '1rem' }}
                className={styles.btn}
                onClick={() => this.unselectAllUserFxn()}>Unselect Visible
              </Button>
            </Col>
            {/* Drop Lead Action */}
            <RightsWrapper myRight={"dropLead.view"}>
              <Col span={4}>
                <Popconfirm
                  title="Are you sure to drop this inquiry?"
                  onConfirm={() => {
                    this.dropLeads()
                  }}
                  onCancel={() => {
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    className={styles.btn}
                    style={{ marginLeft: 20 }}
                    type="primary">Drop Selected Leads
                  </Button>
                </Popconfirm>
              </Col>
            </RightsWrapper>
            {/* Drop Lead View */}
            <RightsWrapper myRight={"showDropLead.view"}>
              <Col span={4}>
                <Button
                  className={styles.btn}
                  style={{ marginLeft: '10px' }}
                  type="primary"
                  onClick={() => {
                    this.toggleDroppedLeads()
                  }}
                >{this.state.showDropped ? "Show All Leads" : 'Show Dropped Leads'}
                </Button>
              </Col>
            </RightsWrapper>
            {/* Change Counsellor */}
            <RightsWrapper myRight={"changeCounsellor.view"}>
              <Col span={4}>
                <Button className={styles.btn}
                  type="primary"
                  onClick={() => {
                    this.changeCounsellorInBulk()
                  }}>Change Counsellor</Button>
              </Col>
            </RightsWrapper>
          </Row>
        </Card>
        <Card bordered={true}>
          <Search id="search-student-input" placeholder="Search Student" onSearch={value => this.changeSearchValue(value)} enterButton />
          <TableComp
            id={"allCounsellingDesk"}
            columns={columns}
            ref={this.table}
            showSelector={true}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 1250 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>

        <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              courseDrawer: false,
            });
          }}
          visible={this.state.courseDrawer}
          width={1200}
        >
          <div>
            <h3 style={{ fontSize: 20, padding: 10 }}>Selected Courses</h3>
            <Table
              bordered={true}
              columns={courseColumns}
              dataSource={this.state.courseList}
              pagination={false}
            />
          </div>
        </Drawer>
      </PageHeaderWrapper >
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounsellingDesk);
